// libraries
import React, { useState, useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import SinglePagePDFViewer from './singlePagePDF';
import { Link, useParams, Redirect } from 'react-router-dom';
import cyber from '../../public/cyber.jpg';
import ai from '../../public/ai.jpg';
import webinarImageFile from '../../public/webinarThumb.jpg';
import Image from './../../utils/components/Image';
// React hooks
import fopPDF from '../../public/FOPPPT.pdf';
import aicte from '../../public/aicte.png';
import mu from '../../public/mu.png';
import svv from '../../public/svv.png';

import { GlobalContext } from '../../state-manager/globalState';
import ProfSahu from '../../public/ProfSahu.jpg';
import MrAmey from '../../public/MrAmey.jpg';
import intersnhip from '../../public/checklist1.png';
import iiclogo from '../../public/IICLOGO.png';
import icast from '../../public/icast.png';
import webinar1PDF from '../../public/Webinar1.pdf';
import webinar2PDF from '../../public/Webinar2.pdf';
import { ToastContainer, toast } from 'react-toastify';
// Components
import 'react-toastify/dist/ReactToastify.css';
import { formatNumber } from '../../utils/utils';

import axios from 'axios';

import YouTube from 'react-youtube';
var FileSaver = require('file-saver');
function validateEmail (email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function isIOSDevice () {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}
const notify = text =>
  toast.success(text, {
    position: 'top-right',
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });
const notifyError = text =>
  toast.error(text, {
    position: 'top-right',
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });
const opts = {
  // height: '400px',
  frameborder: 0,
  width: '100%',
  playerVars: {
    frameborder: 0,
    // https://developers.google.com/youtube/player_parameters
    autoplay: 0
  }
};

function WebinarDetails () {
  const [searchKey, setSearchKey] = useState('');

  function handleChangeSearchKey (search_key) {
    setSearchKey(search_key);
  }

  function handleKeyPress (target) {
    if (target.charCode == 13) {
      handleSubmit();
    }
  }
  var ICASTMultiple = ["2017.jaya.tanwani@ves.ac.in",
    "2017.sagar.sidhwa@ves.ac.in",
    "aarti.sahitya@somaiya.edu",
    "aniket.sy@somaiya.edu",
    "anjali.yeole@ves.ac.in",
    "disha.makwana@somaiya.edu",
    "erajohri@somaiya.edu",
    "hariram@somaiya.edu",
    "hbhor@somaiya.edu",
    "jiteshgharat25@gmail.com",
    "jyoti@somaiya.edu",
    "kiran.rathod@somaiya.edu",
    "lindaj@sjcem.edu.in",
    "mdesai@somaiya.edu",
    "mdsaquibfaraz@gmail.com",
    "mohammadbilal@somaiya.edu",
    "nehal.thaker@somaiya.edu",
    "ngharat@somaiya.edu",
    "ninad.w@somaiya.edu",
    "nshah@somaiya.edu",
    "prashant27@somaiya.edu",
    "psmerchant21@gmail.com",
    "pupadhay@somaiya.edu",
    "radhika.kotecha@somaiya.edu",
    "rasika.naik@ves.ac.in",
    "reena.l@somaiya.edu",
    "sagar.mhatre@somaiya.edu",
    "sarita.ambadekar@somaiya.edu",
    "sarita.r@somaiya.edu",
    "satyampandey91298@gmail.com",
    "sharmila.sengupta@ves.ac.in",
    "sheetaljagtap@somaiya.edu",
    "shreyas.shedge17@siesgst.ac.in",
    "simrannalge12@gmail.com",
    "soumi.banerjee@rait.ac.in",
    "spatil@somaiya.edu",
    "sshah@somaiya.edu",
    "tdhake@somaiya.edu",
    "udayrote@somaiya.edu",
    "vsagvekar@somaiya.edu",
    "waheeda.dhokley@mhssce.ac.in"]
  function handleSubmit () {
    setIsLoading(true);
    notify();
    if (validateEmail(searchKey)) {
      setIsLoading(true);
      var headers = {
        'Content-Type': 'application/pdf'
      }
      var type = 'application/pdf'
      var ext = ".pdf"

      if (webinar.link == "getCertificateICAST2021") {
        if (ICASTMultiple.includes(searchKey.toLowerCase().trim())) {
          headers = {
            'Content-Type': 'application/zip'
          }
          type = 'application/zip'
          ext = ".zip"
        }
        else {
          headers = {
            'Content-Type': 'application/pdf'
        
          }
          type = 'application/pdf'
          ext = ".pdf"
          
        }
      }


      axios
        .get(
          'https://certi-downloaded-v2.herokuapp.com/' +
          webinar.link +
          '/' +
          searchKey.toLowerCase().trim(),
          {
            headers: headers,
            responseType: 'blob'
          }
        )
        .then(async function (response) {
          // console.log(response);

          if ((response.status = 200)) {
            var out = new Blob([response.data], { type: type });
            FileSaver.saveAs(
              out,
              webinar.pdfdetails + ' (' + searchKey + ')' + ext
            );

            // if (isIOSDevice()) {
            //   var out = new  Blob([response.data], { type: 'application/pdf' });
            //   console.log("I am an IOS device!");
            //   window.open(out, '_blank');
            // }
            // else {
            //   const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            //   const link = document.createElement("a");
            //   link.href = url;
            //   link.setAttribute(
            //     "download",
            //     webinar.pdfdetails +
            //     " (" +
            //     searchKey +
            //     ")" +
            //     ".pdf"
            //   );

            //   document.body.appendChild(link);
            //   link.click();
            // }
            notify('Certificate Downloaded! Thank you for attending!');
            setIsLoading(false);
          } else {
            console.log(response.data.message);
            notifyError(response.data.message);
            setIsLoading(false);
          }
        })
        .catch(async function (error) {
          let resBlob = error.response.data;
          let resData = null;

          try {
            let resText = await new Promise((resolve, reject) => {
              let reader = new FileReader();
              reader.addEventListener('abort', reject);
              reader.addEventListener('error', reject);
              reader.addEventListener('loadend', () => {
                resolve(reader.result);
              });
              reader.readAsText(resBlob);
            });
            resData = JSON.parse(resText); // <--- try to parse as json evantually
          } catch (err) {
            // ignore
          }
          console.log(resData);
          setIsLoading(false);
          notifyError(resData.message);
        });
    } else {
      setIsLoading(false);
      alert('Invalid Email Address');
    }
  }
  // react hooks

  const [isLoading, setIsLoading] = useState(true);
  const [webinar, setwebinar] = useState(null);

  const { id } = useParams();
  const webinarDetails = {
    INNOVATHON: {
      name: 'Innovathon 2021',
      banner: '',
      link: 'getInnovathonCertificate',
      fileName:
        'Certificate - Innovathon 2021 ',
      registrations: 60,
      bannerImage: ai,
      ytlink: 'https://youtu.be/cZ7D6HBcJcA',
      speaker: '24 Hours Virtual Hackathon organised by the Institution Innovation Council (IIC)',
      speakerImage: iiclogo,
      details: '',
      pdfdetails:
        'Certificate - Innovathon 2021 ',
      date: 'March 20-21, 2021',
      rlink: webinar1PDF,
      errorM: 'Oops!! No Records found with this email address.'
    },

    ICAST2021: {
      name: 'ICAST 2021',
      banner: '',
      link: 'getCertificateICAST2021',
      fileName:
        'Certificate - ICAST 2021 ',
      registrations: 533,
      bannerImage: icast,
      ytlink: 'https://youtu.be/cZ7D6HBcJcA',
      speaker: '4th International Conference on Advances in Science and Technology',
      speakerImage: icast,
      details: '',
      pdfdetails:
        'Certificate - ICAST 2021 ',
      date: 'May 7th/8th, 2021',
      rlink: webinar1PDF,
      errorM: 'Oops!! No Records found with this email address.'
    },
    DEBATE: {
      name: 'Innovation Debate 2021',
      banner: '',
      link: 'getInnovationDebateCertificate',
      fileName:
        'Certificate - Innovation Debate 2021 ',
      registrations: 17,
      bannerImage: ai,
      ytlink: 'https://youtu.be/cZ7D6HBcJcA',

      speaker: 'Debate Competition organised by the Institution Innovation Council (IIC)',
      speakerImage: iiclogo,
      details: '',
      pdfdetails:
        'Certificate - Innovation Debate 2021 ',
      date: 'March 18, 2021',
      rlink: webinar1PDF,
      errorM: 'Oops!! No Records found with this email address.'
    },
    FOPOS2021: {
      name: 'Faculty Orientation Programme (FOP)',
      banner: '',
      link: 'getCertificateFOP2021',
      fileName:
        'Certificate - Faculty Orientation Programme (FOP) Course: Operating Systems (ITC403) & Unix Lab (ITL402)',
      registrations: 45,
      bannerImage: ai,
      ytlink: 'https://youtu.be/cZ7D6HBcJcA',

      speaker: 'Course: Operating Systems (ITC403) & Lab: Unix Lab (ITL402)',
      speakerImage: svv,
      details: '',
      pdfdetails:
        'Certificate - Faculty Orientation Programme (FOP) Course: Operating Systems (ITC403) & Unix Lab (ITL402)',
      date: 'Feb 02, 2021',
      rlink: webinar1PDF,
      errorM: 'Oops!! No Records found with this email address.'
    },
    STTP2021AI2: {
      name: 'AICTE SPONSORED VIRTUAL STTP 2020',
      banner: '',
      link: 'getCertificateSTTP2',
      ytviews: 1963,
      fileName:
        'Certificate - AICTE SPONSORED VIRTUAL STTP ON LEVERAGING AI & DATA ANALYTICS FOR HEALTHCARE',
      registrations: 92,
      bannerImage: ai,
      ytlink: 'https://youtu.be/25JyVUIoNl0',
      ytID: '25JyVUIoNl0',
      speaker:
        'AICTE SPONSORED VIRTUAL STTP ON LEVERAGING AI & DATA ANALYTICS FOR HEALTHCARE',
      speakerImage: aicte,
      details: '',
      pdfdetails:
        'Certificate - AICTE SPONSORED VIRTUAL STTP ON LEVERAGING AI & DATA ANALYTICS FOR HEALTHCARE',
      date: 'Jan 2021',
      rlink: webinar1PDF,
      errorM: 'Oops!! No Records found with this email address.'
    },
    STTP2021AI: {
      name: 'AICTE SPONSORED VIRTUAL STTP 2020',
      banner: '',
      link: 'getCertificateSTTP1',
      ytviews: 1452,
      fileName:
        'Certificate - AICTE SPONSORED VIRTUAL STTP ON LEVERAGING AI & DATA ANALYTICS FOR HEALTHCARE',
      registrations: 64,
      bannerImage: ai,
      ytlink: 'https://youtu.be/cZ7D6HBcJcA',
      ytID: 'cZ7D6HBcJcA',
      speaker:
        'AICTE SPONSORED VIRTUAL STTP ON LEVERAGING AI & DATA ANALYTICS FOR HEALTHCARE - S2',
      speakerImage: aicte,
      details: '',
      pdfdetails:
        'Certificate - AICTE SPONSORED VIRTUAL STTP ON LEVERAGING AI & DATA ANALYTICS FOR HEALTHCARE',
      date: 'Dec 2020',
      rlink: webinar1PDF,
      errorM: 'Oops!! No Records found with this email address.'
    },
    SummerInternship2020: {
      name: 'Summer Internship 2020',
      banner: '',
      link: 'getSummerInternship2020',
      ytviews: 2005,
      fileName: 'Summer Internship 2020 - Towards Industry 4.0',
      registrations: 302,
      bannerImage: ai,
      ytlink: 'https://youtu.be/JabrI-qU7-M',
      ytID: 'i1HWvv8yC70',
      speaker: 'Towards Industry 4.0',
      speakerImage: intersnhip,
      details: '',
      pdfdetails: 'Certificate - Summer Intership 2020 - Towards Industry 4.0',
      date: 'June 2020',
      rlink: webinar1PDF,
      errorM: 'Oops!! No Records found with this email address.'
    },
    webinar1: {
      name: 'Webinar 1 on Artificial Intelligence',
      banner: '',
      link: 'getCertificateWebinar1',
      ytviews: 9004,
      fileName:
        'Webinar - 1 (Artificial Intelligence) National-Level Webinar Series on Emerging Areas of Technology by KJSIEIT',
      registrations: 2100,
      bannerImage: ai,
      ytlink: 'https://youtu.be/JabrI-qU7-M',
      ytID: 'JabrI-qU7-M',
      speaker: 'Dr. G. P. Sahu',
      speakerImage: ProfSahu,
      details: 'Artificial Intelligence',
      pdfdetails:
        'Certificate - KJSIEIT National Level Webinar Series - Webinar 1- AI',
      date: 'July 13, 2020',
      rlink: webinar1PDF,
      errorM:
        "You hadn't filled the Attendance/Feedback Form for this Webinar. Hence Certificate of Participation cannot be issued."
    },
    webinar2: {
      name: 'Webinar 2 on Cyber Security',
      banner: '',
      fileName:
        'Webinar - 2 (Cyber Security) National-Level Webinar Series on Emerging Areas of Technology by KJSIEIT',
      link: 'getCertificateWebinar2',
      ytviews: 8101,
      ytID: 'VS7UaBPvjds',
      rlink: webinar2PDF,
      registrations: 1904,
      bannerImage: cyber,
      speaker: 'Mr. Amey Tambe',
      speakerImage: MrAmey,
      ytlink: 'https://youtu.be/VS7UaBPvjds',
      pdfdetails:
        'Certificate - KJSIEIT National Level Webinar Series - Webinar 2 - CS',
      details: 'Cyber Security',
      date: 'July 14, 2020',
      errorM:
        "You hadn't filled the Attendance/Feedback Form for this Webinar. Hence Certificate of Participation cannot be issued."
    }
  };

  useEffect(() => {
    setwebinar(webinarDetails[id]);
    setIsLoading(false);
  }, []);

  if (isLoading)
    return (
      <div className="webinar-details">
        <div className="loading">Loading</div>
      </div>
    );

  if (webinar && !isLoading) {
    // necessary data for rendering
    const {
      name,
      ytviews,
      registrations,
      bannerImage,
      ytlink,
      link,
      speaker,
      speakerImage,
      date,
      ytID,
      details,
      rlink,
      fileName
    } = webinar;

    return (
      <div className="webinar-details">
        <Helmet>
          <title>
            {' '}
            {`${name} - K. J. Somaiya Institute of Engineering and Information Technology`}
          </title>
          {/* <meta
            name="description"
            content={`NLWS - K. J. Somaiya Institute of Engineering and Information Technology`}
          /> */}
        </Helmet>
        <ToastContainer />
        <div className="top-bar">
          <Link to="/events" className="btn-back icon-only">
            <i style={{ color: '#b7202e' }} className="fa fa-arrow-left" />{' '}
          </Link>
          <div className={`hashTitle`}>
            <h4 className="title">{name}</h4>
          </div>
        </div>

        <h2 className="title">{date}</h2>
        {/* <h2>In association with</h2> */}
        {/* <img width="50%" height="50%" src={iiclogo} /> */}
        <div className="details">
          <div className="chart-infos">
            {/* <div className="chart">
              <img
                style={{ borderRadius: "505px" }}
                width="90%"
                height="80%"
                src={bannerImage}
              ></img>
            
            </div> */}
            <div className="infos">
              <img
                style={{ borderRadius: '50%' }}
                width="30%"
                height="30%"
                src={speakerImage}
              />

              <h2
                style={{
                  textAlign: 'center'
                }}
              >
                {speaker}
              </h2>
              <div className="rates">
                {ytviews && (
                  <div className="card">
                    <h6
                      style={{
                        textAlign: 'center'
                      }}
                    >
                      <i className="fab fa-youtube" /> Views
                    </h6>
                    <small
                      style={{
                        textAlign: 'center'
                      }}
                      className={`rate ${4 > 0 ? 'up' : 'down'}`}
                    >
                      <i
                        className={`fa fa-long-arrow-alt-${4 < 0 ? 'down' : 'up'
                          }`}
                      />{' '}
                      {`${formatNumber(ytviews)}`}{' '}
                    </small>
                  </div>
                )}
                <div className="card">
                  <h6>
                    <i className="fab fa-redhat" /> Participants
                  </h6>
                  <small
                    style={{
                      textAlign: 'center'
                    }}
                    className={`rate ${4 > 0 ? 'up' : 'down'}`}
                  >
                    {`${formatNumber(registrations)}`}{' '}
                  </small>
                </div>
              </div>
              <div className="rates">
                <div
                  style={{
                    width: '350px',
                    alignContent: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'center'
                  }}
                  className="card"
                >
                  <h2 style={{ textAlign: 'center' }}>
                    🎉 Download Your Certificate
                  </h2>
                  <div className="search" method="get">
                    <input
                      style={{ width: '350px' }}
                      onChange={e => handleChangeSearchKey(e.target.value)}
                      type="text"
                      value={searchKey}
                      placeholder="Email"
                      onKeyPress={handleKeyPress}
                    />
                    <button onClick={handleSubmit}>
                      <i className="fa fa-download" />
                    </button>
                  </div>
                  {link == 'getSummerInternship2020' && (
                    <>
                      <div>
                        <h3>
                          {'Feedback Link - '}{' '}
                          <a href="https://forms.gle/euDcYw6AruNr5RJt6 ">
                            {' '}
                            Click Here
                          </a>
                        </h3>
                      </div>
                    </>
                  )}
                  {link == 'getCertificateFOP2021' && (
                    <>
                      <div
                        style={{
                          alignContent: 'center',
                          justifyContent: 'center',
                          alignItems: 'center',
                          alignSelf: 'center',
                          textAlign: 'center'
                        }}
                      >
                        <Link
                          style={{
                            textAlign: 'center'
                          }}
                          to="/resource/FOPOS"
                          className="btn-primary lr"
                        >
                          <i
                            class="fa fa-external-link-alt"
                            aria-hidden="true"
                          ></i>
                          Learning Resources
                        </Link>
                      </div>
                    </>
                  )}
                  {link == 'getCertificateSTTP1' && (
                    <>
                      <div
                        style={{
                          alignContent: 'center',
                          justifyContent: 'center',
                          alignItems: 'center',
                          alignSelf: 'center',
                          textAlign: 'center'
                        }}
                      >
                        <Link
                          style={{
                            textAlign: 'center'
                          }}
                          to="/resource/STTP1"
                          className="btn-primary lr"
                        >
                          <i
                            class="fa fa-external-link-alt"
                            aria-hidden="true"
                          ></i>
                          Learning Resources
                        </Link>
                      </div>
                    </>
                  )}

                  {link == 'getCertificateSTTP2' && (
                    <>
                      <div
                        style={{
                          alignContent: 'center',
                          justifyContent: 'center',
                          alignItems: 'center',
                          alignSelf: 'center',
                          textAlign: 'center'
                        }}
                      >
                        <Link
                          style={{
                            textAlign: 'center'
                          }}
                          to="/resource/STTP2"
                          className="btn-primary lr"
                        >
                          <i
                            class="fa fa-external-link-alt"
                            aria-hidden="true"
                          ></i>
                          Learning Resources
                        </Link>
                      </div>
                    </>
                  )}

                  {details && (
                    <>
                      {' '}
                      <h2>Resources</h2>
                      <div className="search" method="get">
                        <a
                          href={rlink}
                          download={fileName}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-download" /> PPT - {details}
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div></div>
            </div>
            {ytID && (
              <div style={{ maxWidth: '650px' }} className="chart">
                <div className="card">
                  {ytID && (
                    <>
                      <h2 style={{ textAlign: 'center' }}>
                        <i className="fab fa-youtube" /> Video
                    </h2>
                      <YouTube videoId={ytID} opts={opts} />
                    </>
                  )}

                </div>
              </div>
            )}

            {link == 'getCertificateFOP2021' && (
              <div style={{ maxWidth: '650px' }} className="chart">
                <div className="card">
                  <h2 style={{ textAlign: 'center' }}>
                    <i className="fa fa-file-powerpoint" /> Reference Slides
                    </h2>
                  <SinglePagePDFViewer pdf={fopPDF} />
                  <a
                    href={fopPDF}
                    download={'OS-UL FOP - Feb 02 2021 - Reference Slides'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary lr"
                    style={{ marginTop: '10px' }}
                  >
                    <i className="fa fa-download" /> Download {details}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <div className="image">
          <img width="120%" height="90%" src={webinarImageFile} />
        </div> */}
      </div>
    );
  }
  return <Redirect to="/" />;
}

export default WebinarDetails;
